import type { TermsData } from './terms.types';

const data: TermsData = {
  seo: {
    title: 'Terms and Conditions | E-School Cambodia',
    description: 'Learn about the terms and conditions of using the E-School Cambodia mobile application.',
  },
  hero: {
    badge: 'Official Document',
    title: 'Terms and Conditions',
    subtitle: 'E-School Cambodia Mobile Application',
  },
  intro: {
    text: 'Hello everyone! Thank you for taking the time to visit this page to learn more about the terms of use. We have created an application for personal mobile use that provides you with services that assist or coach yourself directly by participating through watching additional tutorial videos to achieve personal success. You can study regularly and can order extra lessons from one to one. <strong>"E-School Cambodia"</strong> is the name of the mobile application where you can get content of additional lessons on general knowledge and foreign language classes to make your study more effective than before. Once again, we thank you for reading and understanding about us.',
  },
  sections: [
    {
      number: '1',
      title: 'Agreement with the Terms of Use',
      paragraphs: [
        'These terms of use describe instructions for using this mobile application. By accessing this mobile application, you agree to our terms of use. If you do not yet agree with our terms of use, please do not go any further. The E-School Cambodia mobile application and the various services inside are provided by <strong>E-SCHOOL (CAMBODIA) CO.,LTD</strong>.',
      ],
    },
    {
      number: '2',
      title: 'Modification of the Terms of Use',
      paragraphs: [
        'Everything changes and so do we. In fact, it means we may modify the terms of use, including privacy policy and other agreements, based on our actual situation. But when we really need to modify the terms of use, we will definitely inform you through this personal mobile application or by email, etc. (if any). These new modifications will take effect immediately. Therefore, if you still use this mobile application after the modifications are made, it means you acknowledge and agree to those changes, and we thank you once again in advance.',
      ],
    },
    {
      number: '3',
      title: 'Communication',
      paragraphs: [
        'By using the E-School Cambodia application on mobile, you agree to receive communications regarding account information in this mobile application via email, notification, or phone. We may contact you to guide you on how to use, explain other benefits in the application, or show you how to pay for membership, etc.',
      ],
    },
    {
      number: '4',
      title: 'Privacy Policy',
      paragraphs: [
        'The information you provide to us about your identity is subject to the Privacy Policy, which is an additional condition and is detailed in the <strong>"Privacy Policy"</strong> page.',
      ],
    },
    {
      number: '5',
      title: 'Membership and Payment',
      subsections: [
        {
          num: '5.1',
          title: 'Membership',
          paragraphs: [
            'You must link your account in the app with internet connection and make payment through any available method we offer to become a member of the E-School Cambodia mobile app. We will charge the membership fee at the beginning of the membership period and provide membership for 1 year or 365 days starting from the day the payment method is selected and processed successfully. After the membership expires, you must select to rejoin by yourself. We will not charge you without your prior knowledge.',
          ],
        },
        {
          num: '5.2',
          title: 'Regular User',
          paragraphs: [
            'Generally, users who download the E-School Cambodia mobile app from any operating system store (iOS App Store or Android Play Store) can register to use our app free of charge. You can join as a member immediately after downloading our app, and simply by downloading our app for free, you will already get a number of good lessons, and we really provide them for free (Free).',
          ],
        },
        {
          num: '5.3',
          title: 'Charging',
          subsections: [
            {
              num: 'a)',
              title: 'Annual Billing',
              paragraphs: [
                'When you decide to join as a member and enter your payment method details, you authorize us to charge you the amount shown and agreed upon by you for that one time only. Our membership plan is for 12 months, where we will charge only once for 12 months, and we will not automatically charge you again at the end of the period.',
              ],
            },
            {
              num: 'b)',
              title: 'Price Variations',
              paragraphs: [
                'We reserve the right to modify the prices of our services according to our actual needs. All changes in pricing will take effect immediately after the announcement is published. However, we will inform you in advance.',
              ],
            },
            {
              num: 'c)',
              title: 'Refund Request',
              paragraphs: [
                'All completed payments cannot be exchanged for cash or other forms of credit. We (the team) do not have the responsibility or obligation to apply for waivers or refunds to you.',
              ],
            },
            {
              num: 'd)',
              title: 'Cancellation of Membership',
              paragraphs: [
                'Once you join the membership of E-School Cambodia mobile app, you cannot cancel the plan to request a refund. We are committed to serving you with the best services. If you are dissatisfied for any reason, we urge you to notify us so that we can resolve it for you.',
              ],
            },
          ],
        },
      ],
    },
    {
      number: '6',
      title: 'Usage',
      paragraphs: [
        "The E-School Cambodia mobile application does not limit the age of users. All Cambodian people who can understand Khmer and wish to continue developing their knowledge can use our application. The important thing is to have a mobile phone with sufficient capacity to install this app and must also connect to the internet. Internet data usage is the user's personal expense.",
        'Lessons and other data in the E-School Cambodia mobile app are allowed for learning and self-development only. Downloading, recording video or audio, and all technical copying for redistribution or personal business use are strictly prohibited. All data in this mobile app is the intellectual property of <strong>E-SCHOOL (CAMBODIA) CO.,LTD</strong>, which is protected by the intellectual property laws of the Kingdom of Cambodia.',
        'Please remember that our services sometimes require sending verification codes to your phone number by SMS. An account is linked to one phone number and can be used to log in on only one phone at a time. Membership is also provided based on the registered phone number, and you cannot transfer membership to other phone numbers (or accounts).',
        'To continue using E-School Cambodia app, you must be using the latest version of the app. But the good news is our app is small in size and downloading does not take much time.',
      ],
    },
    {
      number: '7',
      title: 'Account',
      paragraphs: [
        'A user account must be created beforehand by registering and entering a phone number and username of your choice. The only personal information we collect from you is the phone number you use for registration. An account is linked to only one phone number and can be used on only one device (mobile phone) at a time.',
        'Using the E-School Cambodia app is for personal self-development in terms of mindset and additional knowledge, so you should not share your account with others, even close friends.',
      ],
    },
    {
      number: '8',
      title: 'Disclaimer of Warranties and Limitations',
      paragraphs: [
        "To the maximum extent permitted by applicable law, we strive to provide the best services we can, and all videos and lessons related to this service or any other process related to us are provided 'as is' and without warranty. Under no circumstances shall E-School Cambodia and E-SCHOOL (CAMBODIA) CO.,LTD be liable to users for personal injury or any special, incidental, or indirect damages.",
        'If any provision of these terms of use is held to be invalid, illegal, or unenforceable, the remaining provisions shall continue to be valid, legal, and enforceable.',
      ],
    },
    {
      number: '9',
      title: 'Special Offers',
      paragraphs: [
        'Sometimes our app may provide you with special programs such as discounts on lessons or membership fees, which generally come with certain conditions. All users will receive information about those offers.',
      ],
      subsections: [
        {
          num: '9.1',
          title: 'Copyright',
          paragraphs: [
            'E-School Cambodia protects original intellectual property. All of our services, including data we put in the app and all interfaces created, such as text, images, graphics, logos, style, photos, marks, buttons, sound, video, digital compilation, data, and software, are the property of E-School Cambodia or our data providers and are protected by copyright laws.',
          ],
        },
        {
          num: '9.2',
          title: 'Trademarks',
          paragraphs: ['E-School Cambodia is a registered trademark of <strong>E-SCHOOL (CAMBODIA) CO., LTD</strong>.'],
        },
        {
          num: '9.3',
          title: 'Claims of Copyright Infringement',
          paragraphs: [
            'If for any reason you believe that your work has been reproduced or redistributed in a way that constitutes copyright infringement, or know that products of infringement are on the E-School Cambodia app, please notify us through our <strong>Facebook page: E-School Cambodia</strong>.',
          ],
        },
      ],
    },
    {
      number: '10',
      title: 'Use of Information You Provide to Us',
      paragraphs: [
        'The E-School Cambodia app does not have full rights to use information and anything you submit to us in the form of comments, complaints, compliments, and responses in questionnaires, surveys, or posts on our Facebook page as well as inside the mobile app. We do not accept information or suggestions in any form sent to us unsolicited, and are not responsible for any similarities to information sent to us.',
      ],
    },
    {
      number: '11',
      title: 'Choice of Law',
      paragraphs: [
        'These terms of use are governed by and construed in accordance with the laws of the Kingdom of Cambodia without regard to conflict of laws principles. You may also be entitled to certain consumer protections under the laws of the country or jurisdiction in which you reside.',
      ],
    },
    {
      number: '12',
      title: 'Customer Service',
      paragraphs: [
        'We, the team of E-School Cambodia, are committed to serving and resolving all issues for users of our mobile application to the best of our ability. If you encounter any problems and need assistance from us regarding registration, logging into accounts, membership, or other services, please send us a message via our <strong>Facebook page: E-School Cambodia</strong>.',
      ],
    },
    {
      number: '13',
      title: 'Links',
      paragraphs: [
        'Some links, such as hyperlinks, used in our services may take you to other websites or interfaces that are not controlled directly by us. But as long as the E-School Cambodia app has not reviewed those sources, we are not responsible for the data or privacy policies of those sources.',
      ],
    },
    {
      number: '14',
      title: 'Severability',
      paragraphs: [
        'If any provision of these terms is held to be invalid or unenforceable for any reason or to any extent, the remaining provisions shall continue to be valid, legal, and fully enforceable in any form.',
      ],
    },
    {
      number: '15',
      title: 'Contact Us',
      paragraphs: [
        "For questions regarding these terms of use, please contact us via our team's phone number <strong>015 372 363 / 085 372 363 / 060 372 363</strong> or send a letter directly to our office located on <strong>Kings View Office Building, Keo Chenda Street, Phum 3, Sangkat Chroy Changvar, Khan Chroy Changvar, Phnom Penh, Kingdom of Cambodia.</strong>",
      ],
    },
  ],
};

export default data;
